/**
* @Author: zachalam
* @Date:   2017-04-12T14:07:32-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-04-12T14:07:32-07:00
*/


import moment from 'moment-timezone';
import { refreshUserToken } from './actions/authActions';


export function jwt({ dispatch, getState }) {

  return (next) => (action) => {

      // only worry about expiring token for async actions
      if (typeof action === 'function') {

          if (getState().auth && getState().auth.jwToken) {

              // decode jwt so that we know if and when it expires
              var tokenExpiration = getState().auth.jwtUnixExpiration;

              // refresh token at most 30 seconds before expiration.
              if (tokenExpiration && (moment().unix() >= tokenExpiration-30)) {

                  // make sure we are not already refreshing the token
                  if (!getState().auth.freshTokenPromise) {
                      return refreshUserToken().then(() => next(action));
                  } else {
                      return getState().auth.freshTokenPromise.then(() => next(action));
                  }
              }
          }
      }
      return next(action);
  };
}



// WEBPACK FOOTER //
// ./src/jwt.js